import moment from "moment/moment";

export const ExpenseManagementGoLiveDate = "01/24/2025";
export const FirstDayOfExistenceForHsaAccounts = moment("Jan 01, 2004");